'use client';
var getTruncate = function(truncate) {
    if (truncate === "start") {
        return {
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            direction: "rtl",
            textAlign: "right"
        };
    }
    return {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    };
};

export { getTruncate };
